import React from 'react';
import { Section } from './ui/Section';
import { Volume2, Scissors, Heart } from 'lucide-react';
export function BenefitsSection() {
  return <Section background="cream" data-id="element-1">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-2">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-stone-900 mb-4" data-id="element-3">
          Más que una receta, es una transformación
        </h2>
        <p className="text-stone-600 text-lg" data-id="element-4">
          Cuando dominas la técnica, el resultado cambia por completo.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-5">
        {/* Benefit 1 */}
        <div className="bg-white p-8 rounded-2xl shadow-sm border border-stone-100 text-center group hover:-translate-y-1 transition-transform duration-300" data-id="element-6">
          <div className="w-16 h-16 mx-auto bg-amber-50 rounded-full flex items-center justify-center mb-6 group-hover:bg-amber-100 transition-colors" data-id="element-7">
            <Volume2 className="w-8 h-8 text-amber-600" data-id="element-8" />
          </div>
          <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-9">Sonido Real</h3>
          <p className="text-stone-600 leading-relaxed" data-id="element-10">
            Ese "crack" satisfactorio en cada bocado que hace que todos en la
            mesa guarden silencio para escuchar. Música para tus oídos.
          </p>
        </div>

        {/* Benefit 2 */}
        <div className="bg-white p-8 rounded-2xl shadow-sm border border-stone-100 text-center group hover:-translate-y-1 transition-transform duration-300" data-id="element-11">
          <div className="w-16 h-16 mx-auto bg-amber-50 rounded-full flex items-center justify-center mb-6 group-hover:bg-amber-100 transition-colors" data-id="element-12">
            <Scissors className="w-8 h-8 text-amber-600" data-id="element-13" />
          </div>
          <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-14">
            Corte de Cirujano
          </h3>
          <p className="text-stone-600 leading-relaxed" data-id="element-15">
            Porciones perfectas, rectangulares y limpias que no se desarman ni
            se aplastan al servirlas. Presentación de vitrina.
          </p>
        </div>

        {/* Benefit 3 */}
        <div className="bg-white p-8 rounded-2xl shadow-sm border border-stone-100 text-center group hover:-translate-y-1 transition-transform duration-300" data-id="element-16">
          <div className="w-16 h-16 mx-auto bg-amber-50 rounded-full flex items-center justify-center mb-6 group-hover:bg-amber-100 transition-colors" data-id="element-17">
            <Heart className="w-8 h-8 text-amber-600" data-id="element-18" />
          </div>
          <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-19">
            Orgullo Total
          </h3>
          <p className="text-stone-600 leading-relaxed" data-id="element-20">
            Serás la persona que "trae el postre" a todas las fiestas porque
            nadie creerá que lo hiciste en tu propia cocina.
          </p>
        </div>
      </div>
    </Section>;
}